module.exports = __webpack_public_path__ + "img/LHB.e1393df9.png";